'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeFunnelIcon = function TraceTypeFunnelIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 60 60' }, props),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M8.8 12h42.4v8.3H8.8z' }),
        _react2.default.createElement('path', { fill: '#09ffff', d: 'M8.8 20.3l7.2 2.2h28.6l6.6-2.2H8.8z' }),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M16 22.5h28.2v8.3H16z' }),
        _react2.default.createElement('path', { fill: '#09ffff', d: 'M16 30.9l3.3 2.2H41l3.3-2.2H16z' }),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M19.3 33.1h21.6v8.1H19.3z' }),
        _react2.default.createElement('path', { fill: '#09ffff', d: 'M19.3 41.1l3.9 2.5h13.9l3.9-2.5H19.3z' }),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M23.2 43.6H37V50H23.2z' })
    );
};

exports.default = TraceTypeFunnelIcon;